// @flow

import * as React from 'react';

import { Pizza } from './domain/pizza';
import { impossible } from './domain/utils';
import DishDone from '../../../../assets/images/pages/pizza/fields/pizza_sara_tabeta@3x.png';
import NormalDish from '../../../../assets/images/pages/pizza/fields/pizza_sara_futsu@3x.png';
import PizzaContainer from './PizzaContainer';
import ThickDish from '../../../../assets/images/pages/pizza/fields/pizza_sara_fukkura@3x.png';
import ThinDish from '../../../../assets/images/pages/pizza/fields/pizza_sara_usui@3x.png';

type Props = {
  size: 'normal' | 'medium' | 'large',
  pizza: Pizza,
  ate: boolean,
};

class PizzaDish extends React.Component<Props> {
  get dishImgSrc(): string {
    if (this.props.ate) return DishDone;

    switch (this.props.pizza.crust) {
      case 'thin_crust':
        return ThinDish;
      case 'normal_crust':
        return NormalDish;
      case 'thick_crust':
        return ThickDish;
      default:
        return impossible(this.props.pizza.crust);
    }
  }
  render() {
    return (
      <div className={`pizza-image pizza-dish-container ${this.props.size}`}>
        <img src={this.dishImgSrc} className="pizza-image pizza-dish" />
        {!this.props.ate && <PizzaContainer pizza={this.props.pizza} />}
      </div>
    );
  }
}

export default PizzaDish;
